<template>
    <div>
        <!-- <van-popup
            class="popBox"
            v-model="show"
            position="bottom"
            :style="{ height: '40%' }"
        > -->
        <van-datetime-picker
            class="datetimeBox"
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            @change="onChange"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
        <!-- </van-popup> -->
    </div>
</template>

<script>
import { pathInit } from '../../../store/modules/db';
    export default {
        props:{
            minDate:{
                default:()=>{return new Date((new Date().getFullYear())-8,1,1)}
            }
        },
        name: 'TimePickerFB',
        data() {
            return {
                // show: true,
                // minDate: new Date((new Date().getFullYear())-8,1,1),
                maxDate: new Date(),
                currentDate: new Date(),
                dataList: ''
            }
        },
        created() {
            // this.toGetValues();
        },
        methods: {
            formatter (type,value) {
                if (type === 'year') {
                    return `${value}年`
                } else if (type === 'month') {
                    value = parseInt(value).toString()
                    return `${value}月`
                } else if (type === 'day') {
                    value = parseInt(value).toString()
                    return `${value}日`
                }
                return value
            },
            onChange (picker) {
                // this.dataList = picker.getValues()
                let data = picker.getValues() 
                for(let i = 0, length=data.length;i < length; i++){
                    if(i<(length-1)){
                        this.dataList += parseInt(data[i]) + '-';
                    }else{
                        this.dataList += parseInt(data[i])
                    }
                }
            },
            onConfirm (value) {
                let data = new Date(value)
                let month, r
                if ((data.getMonth() + 1) < 10) {
                    month = '0' + (data.getMonth() + 1)
                } else {
                    month = '' + (data.getMonth() + 1)
                }
                if (data.getDate() < 10) {
                    r = '0' + data.getDate()
                } else {
                    r = '' + data.getDate()
                }
                data = data.getFullYear() + '-' + month + '-' + r;
                this.$emit('getDate',data)
            },
            onCancel () {
                this.$emit('cancelDatePick',false)
            }
        },
    }
</script>

<style lang="less" scoped>
    .datetimeBox{
        color: blue;

        >div.van-picker__columns{
            color: yellow
        }

        li.van-picker-column__item{
            color: red!important;
        }
    }
</style>